import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var Landbot: any;
@Injectable({ providedIn: 'root'})
export class LandBotService {

  private _myLandbot?:any;
  private _backdrop?:HTMLDivElement;

  openBot() {
    if (!this._myLandbot) {

      // Observa les mutacions de l'element passat fins que s'hi afegeixi un 'div',
      // assumeix que aquest és el "backdrop" i hi afegeix un listener 
      const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.nodeName.match(/div/i)) {

              this._backdrop = document.body.lastElementChild! as HTMLDivElement;
              this._backdrop!.addEventListener('click', (evt)=>{
                const dlg = this._backdrop!.firstElementChild as HTMLDivElement;
                dlg.classList.add('will-hide');
                dlg.classList.add('hidden');
                setTimeout(()=>this._backdrop!.classList.add('inactive'),500);
              });

              // només cal fer-ho un cop!
              observer.disconnect();

            }
          });
        });
      });
      // Aguaita quan s'afegeixi el landBot al 'body', i en configura el backdrop
      observer.observe(document.body, { childList: true, subtree: false });

      this._myLandbot = new Landbot.Fullpage({
        configUrl: environment.landbotConfig,
      });
      
    } else {
      const dlg = this._backdrop!.firstElementChild as HTMLDivElement;
      this._backdrop!.classList.remove('inactive');
      dlg.classList.remove('hidden');
      setTimeout(()=>dlg.classList.remove('will-hide'),600)
    }
  }
  
}
